export const DOCUMENT_ADDIN = 'Documents';
